import React, { ReactNode } from 'react';
import styles from './assets/invoice-screen.module.scss';
import classNames from 'classnames';
import InvoicesGrid from './components/InvoicesGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';

import RoleLayout from 'src/components/layout/RoleLayout';
import { IInvoice } from 'src/types/invoice';

import { IServiceType } from '../../../../../../types/service-types';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';
import Loader from '../../../../../../components/Loader';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IAgencyInfo } from '../../../../../../types/app';

export interface StateProps {
    data: Paginated<IInvoice>;
    inProgressCSV: boolean;
    students: SelectObject[];
    inProgress: boolean;
    vendors: SelectObject[];
    providers: SelectObject[];
    districts: SelectObject[];
    serviceTypes: Paginated<IServiceType>;
    agencyInfo: IAgencyInfo | null;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getDataTotal: (params: QueryParams) => void;
    persistInvoice: (params: any, arr: any, res: any) => void;
    getStudents: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    clearTotal: () => void;
}

export interface OwnProps {}
interface OwnState {
    dataToCsV: string[][];
    filters: any;
    isTotal: boolean;
}
export interface Props extends StateProps, DispatchProps, OwnProps {}

class InvoicesList extends React.Component<Props, OwnState> {
    constructor(props: Props) {
        super(props);
        this.getData = this.getData.bind(this);
        this.state = {
            isTotal: false,
            filters: {},
            dataToCsV: [
                [
                    'id',
                    'Invoice Date',
                    'Invoice Total',
                    'Case Number',
                    'Provider',
                    'Student',
                    'Vendor',
                    'District',
                    'Service Type',
                    'Service Period',
                    'Order Type',
                    'Note',
                    'Status',
                ],
            ],
        };
    }
    componentWillUnmount() {
        this.setState({ isTotal: false });
        this.props.clearTotal();
    }
    getTotals() {
        this.props.getDataTotal({ page: 1, filters: this.state.filters });
        this.setState({ isTotal: true });
    }
    getData(data: any) {
        if (data.filters && Object.values(data.filters).length) {
            this.setState({ ...this.state, filters: data.filters });
        }
        if (!this.state.isTotal) {
            data.notTotal = true;
        }

        this.props.getData({ ...data, page: data.page ? data.page : 1 });
    }

    componentDidMount() {
        this.props.getStudents({
            page: 1,
            itemsPerPage: 9000,
        });
        this.props.getDistricts({
            page: 1,
            itemsPerPage: 9000,
        });
        this.props.getVendors({
            page: 1,
            itemsPerPage: 9000,
        });
        this.props.getProviders({
            page: 1,
            itemsPerPage: 9000,
        });

        this.props.getServiceTypes({
            page: 1,
            itemsPerPage: 9000,
        });
        // this.setState({ dataToCsV: groupDataToCsv(this.props.data) });
    }

    public render(): ReactNode {
        const { data, inProgress, students, vendors, districts, serviceTypes, providers, agencyInfo } = this.props;
        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();

        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={`pageHeading`}>
                    <h2 className={`pageHeadingTitle`}>
                        INVOICES {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    {!this.state.isTotal ? (
                        <button onClick={() => this.getTotals()} className={`btn btn-info`}>
                            <FontAwesomeIcon className={'mr-1'} icon={faDollarSign} />
                            Totals
                        </button>
                    ) : null}
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <InvoicesGrid
                        vendors={vendors}
                        getDataCsv={this.props.getDataCsv}
                        serviceTypes={serviceTypes}
                        districts={districts}
                        persistInvoice={(dataReq, sec, third) =>
                            this.props.persistInvoice({ ...dataReq, filters: this.state.filters }, sec, third)
                        }
                        providers={providers}
                        students={students}
                        filters={this.state.filters}
                        data={data}
                        getData={this.getData}
                        inProgressCSV={this.props.inProgressCSV}
                        agencyInfo={agencyInfo}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default InvoicesList;
